import {h, Component} from 'preact';
import cx from 'classnames';
import "./index.less";

export default class LoadingDiv extends Component {
  constructor() {
    super();
    this.state = {
      type: 'wave',
      fadeIn: false
    };
  }

  renderContentByType(type) {
    let renderDom = '';
    switch (type) {
      case 'wave':
        renderDom = (
          <div className="loading-spinner">
            <div className="loading-wave wave-1" />
            <div className="loading-wave wave-2" />
            <div className="loading-wave wave-3" />
            <div className="loading-wave wave-4" />
            <div className="loading-wave wave-5" />
          </div>
        );
        break;
      default:
        renderDom = (
          <div className="loading-spinner">
            <div className="loading-wave wave-1" />
            <div className="loading-wave wave-2" />
            <div className="loading-wave wave-3" />
            <div className="loading-wave wave-4" />
            <div className="loading-wave wave-5" />
          </div>
        );
        break;
    }
    return renderDom;
  }

  componentDidMount() {
    /**
     * 0.5秒后再进行显示
     */
    setTimeout(() => {
      this.setState({
        fadeIn: true
      });
    }, 500);
  }

  render() {
    const { fadeIn, type } = this.state;
    return <div className={cx('loading-div', fadeIn && 'loading-fade-in')}>{this.renderContentByType(type)}</div>;
  }
}
